module.exports = __webpack_public_path__ + "img/verify-2.6284c3aa.svg";